const config = {
  siteUrl: process.env.REACT_APP_SITE_URL || 'https://example.com',
  apiBaseUrl: process.env.REACT_APP_API_BASE_UR || 'https://play.dev.yomobile.xyz/api',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '76557587613-o1m1i3q2jms9p3csgs70inf40o82u00k.apps.googleusercontent.com',
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID || '2775743352667665',
  appleClientId: process.env.REACT_APP_APPLE_CLIENT_ID || 'yo.core.web.auth',
};

export default config;
